import React from "react";

import { useTheme } from "../../../../context/theme";
import { Dimension } from "../../../../types";
import { Box } from "../../../layout";
import { Position as ArrowPosition } from "../../types";

type Props = {
  position: ArrowPosition;
  color?: string;
};

export default function PopupArrow({ position, color }: Props) {
  const style = usePopupArrowStyles(position, color);

  return (
    style && (
      <Box
        zIndex={2}
        width="0px"
        height="0px"
        position="absolute"
        borderStyle="solid"
        borderWidth="large"
        {...style}
      />
    )
  );
}

function usePopupArrowStyles(position: ArrowPosition, color?: string) {
  const theme = useTheme();

  const popupColor = color || theme.foreground;

  switch (position) {
    case "left":
      return {
        right: "-8px",
        borderRightWidth: "none" as Dimension,
        borderColor: `transparent transparent  transparent ${popupColor}`
      };

    case "right":
      return {
        borderLeftWidth: "none" as Dimension,
        left: "-8px",
        borderColor: `transparent ${popupColor}  transparent transparent`
      };

    case "top":
      return {
        bottom: "-8px",
        left: "calc(50% - 8px)",
        borderBottomWidth: "none" as Dimension,
        borderColor: `${popupColor} transparent transparent transparent `
      };

    case "bottom":
      return {
        top: "-8px",
        left: "calc(50% - 8px)",
        borderTopWidth: "none" as Dimension,
        borderColor: `transparent transparent ${popupColor} transparent `
      };

    case "bottomRight":
      return {
        left: "0",
        top: "-8px",
        borderTopWidth: "none" as Dimension,
        borderColor: `transparent transparent ${popupColor} transparent `
      };

    case "topRight":
      return {
        left: "0",
        bottom: "-8px",
        borderBottomWidth: "none" as Dimension,
        borderColor: `${popupColor} transparent transparent transparent `
      };

    case "bottomLeft":
      return {
        top: "-8px",
        right: "0",
        borderTopWidth: "none" as Dimension,
        borderColor: `transparent transparent ${popupColor} transparent `
      };

    case "topLeft":
      return {
        right: "0",
        bottom: "-8px",
        borderBottomWidth: "none" as Dimension,
        borderColor: `${popupColor} transparent transparent transparent `
      };

    default:
      return null;
  }
}
